module.exports = __webpack_public_path__ + "static/media/ic_shopping_cart_white_36px.6be700ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_shopping_cart_white_36px.svg
// module id = 800
// module chunks = 0